<template>
  <div class="table">
    <!-- {{ activeConfigCol }}
    {{ colsConfig }} -->
    <!-- <div ref="tableWrapper" class="table-wrapper" :style="tableStyles"> -->

    <div ref="tableWrapper" class="table-wrapper">
      <!-- {{ data }} -->
      <table ref="table" />
      <div ref="noteWrapper" class="note-abs">
        <div class="note-wrapper">
          <div class="close-wrap" @click="toggleNoteVisibility">
            <div class="icon-close" />
          </div>
          <h4>{{ $t('doc_note') }}</h4>
          <span ref="noteText" />
        </div>
      </div>
    </div>
    <div ref="colDropdown" v-click-outside="onDropdownClickOutside" class="col-dropdown">
      <template v-if="activeConfigCol">
        <div
          class="row sort-option asc"
          :class="{active: activeConfigCol.dir ==='asc'}"
          data-id="asc"
          @click="()=>setTempConfigCol('asc')"
        >
          <div class="icon" /><div class="label">{{ $t('table_ord_asc') }}</div>
        </div>
        <div
          class="row sort-option desc"
          :class="{active: activeConfigCol.dir ==='desc'}"
          data-id="desc"
          @click="()=>setTempConfigCol('desc')"
        >
          <div class="icon" /><div class="label">{{ $t('table_ord_desc') }}</div>
        </div>
        <div
          class="row sort-option reset"
          :class="{active: activeConfigCol.dir ==='reset'}"
          data-id="reset"
          @click="()=>setTempConfigCol('reset')"
        >
          <div class="icon" /><div class="label">{{ $t('table_reset') }}</div>
        </div>
        <div class="row">
          <ColumnFilter
            v-model="activeConfigCol.filter"
            :type="activeConfigCol.filterType"
            :full-range="activeConfigCol.fullRange"
            :data-card="dataCard"
          />
        </div>
        <div class="row actions">
          <div class="action-button" @click="clearColConfig">{{ $t('btn_clean') }}</div>
          <div class="action-button main" @click="applyColConfig">{{ $t('btn_apply') }}</div>
        </div>
      </template>
    </div>
    
    <transition-group name="fade" tag="div">
      <div
        v-for="insight in (visibleInsight?[visibleInsight]:[])"
        :key="insight.id"
        class="insight-tooltip"
        :style="{...insight.style}"
      >
        {{ insight.content }}
      </div>
    </transition-group>
    <!-- <div v-if="hasConditionalHighlight" class="table-footer">
      <div class="text"> {{ conditionalHighlightDesc }}</div>
    </div> -->
  </div>
</template>

<script>
import Size from '@/mixins/Size'
// import CellChartVue from './CellChart.vue'

// import Vue from 'vue'
import $ from 'jquery'

import 'datatables.net-dt'
import 'datatables.net-dt/css/jquery.dataTables.css'

import 'datatables.net-rowgroup-dt'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.css'

import 'datatables.net-fixedcolumns-dt'
import 'datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.css'

import 'datatables.net-fixedheader-dt'
import 'datatables.net-fixedheader-dt/css/fixedHeader.dataTables.css'

import { maskValue } from '@/utils/formatUtils.js'

import ClickOutside from 'vue-click-outside'
import ColumnFilter from './ColumnFilter.vue'

//Para "destruir bien" el "fixedColumns" hya que hacer esto...
$.fn.dataTable.FixedColumns.prototype.destroy = function () {
  Object.keys(this.dom).forEach(k => {
    this.dom[k].off()
    let evts = ['column-visibility', 'draw', 'column-reorder', 'key-focus']
    evts.forEach(k => this.s.dt.off(k))
    this.dom[k].remove()
  })
}

let isOverflownX = el => {
  let { clientWidth, scrollWidth } = el
  let parent = el.closest('.table-container')
  return scrollWidth > clientWidth || el.clientWidth > parent.clientWidth
}

let isOverflownY = ({ clientHeight, scrollHeight }) => {
  return scrollHeight > clientHeight
}

export default {
  components: { ColumnFilter },
  directives: { ClickOutside },
  mixins: [Size],
  props: {
    data: { required: true },
    pivotConfig: { required: true },
    // currentInsight: { required: false },
    showInsights: { default: true },
    canDrillDown: { default: false },
    globalFilter: { default: null },
    dataCard: { type: Object },
  },
  data() {
    return {
      visibleInsight: null,
      colsConfig: {
        currentSort: null,
        filters: null,
      },
      activeConfigCol: null,
      lastScroll: null,
      defaultRowsGrid: 8,
    }
  },
  computed: {
    header() {
      return this.data?.header
    },
    rows() {
      let rowIdsCount = this.pivotConfig.dimensions.filter(dim => dim.role === 'rows').length
      let parsedRows = this.data?.values.map(values => {
        return values.map((value, index) => {
          return index < rowIdsCount ? value : value
        })
      }).map(values=>{
        return values.map((val)=>{
          if(val===undefined) return '-'
          else if (val===null) return '..'
          else return val 
        })
      })
      if (parsedRows.length < this.defaultRowsGrid) {
        let emptyRowObject = []
        for (let j = 0; j < this.header[this.header.length-1].length; j++) {
          emptyRowObject.push({
            label: ' ',
            indentIndex: -1,
            index: 99,
            value: ' ',
            type: 'unselectable',
          })
        }
        for (let i = parsedRows.length; i < this.defaultRowsGrid; i++) {
          parsedRows.push(emptyRowObject)
        }
      }
      return parsedRows
    },
    // tableStyles() {
    //   let rowIdsCount = this.pivotConfig.dimensions.filter(dim => dim.role === 'rows').length
    //   // let totalCols = this.data.values[0]?.length || 0
    //   let totalCols = this.data.header[this.data.header.length - 1].length || 0
    //   if (rowIdsCount > 0 && rowIdsCount === totalCols) return { width: '20%' }
    //   else if (!this.isMobile && totalCols < 5)
    //     return { width: totalCols * 20 + '%', margin: 'auto' }
    //   else return { width: '100%' }
    // },
    // hasConditionalHighlight() {
    //   return (
    //     this.pivotConfig.conditionalHighligh &&
    //     this.pivotConfig.conditionalHighligh.value !== null &&
    //     this.pivotConfig.conditionalHighligh.value !== undefined
    //   )
    // },
    // conditionalHighlightDesc() {
    //   let ch = this.pivotConfig.conditionalHighligh
    //   let header = this.data.header[this.data.header.length - 1].find(h => h.value === ch.value)
    //   let label = header?.label
    //   let text = this.$t('conditional_legend')
    //     .replace('$LABEL$', label)
    //     .replace('$MIN$', ch.range && ch.range[0])
    //     .replace('$MAX$', ch.range && ch.range[1])
    //   return text
    // },
    colFilterTypes() {
      let result = this.data.values.reduce((types, current) => {
        current.forEach((value, index) => {
          let key = index //cols[index].value

          if (current[index] !== null && current[index] !== undefined) {
            // if (types[key][1] < current[index]) types[key][1] = current[index]
            // if (types[key][0] > current[index]) types[key][0] = current[index]
            //console.log('types[key]=' + types[key]);
            //console.log('current[index]=' + JSON.stringify(current[index]));
            if (!types[key]) types[key] = 'range'
            if (isNaN(Number(current[index].value))) types[key] = 'string'
          }
        })
        //console.log(types);
        return types
      }, {})
      // console.log('datatypes', result)
      return result
    },
    colRanges() {
      // let cols = this.data.header[this.data.header.length - 1]
      ////////console.log(this.data);
      let result = this.data.values.reduce((accumulator, current) => {
        //console.log(current);
        current.forEach((value, index) => {
          let key = index //cols[index].value
          accumulator[key] ||= [Infinity, -Infinity]
          if (current[index] !== null && current[index] !== undefined) {
            //console.log('current[index].value=' + current[index].value);
            if (current[index].value && accumulator[key][1] < current[index].value) accumulator[key][1] = current[index].value
            if (current[index].value && accumulator[key][0] > current[index].value) accumulator[key][0] = current[index].value
          }
        })
        return accumulator
      }, {})
      // console.log('AFDAS', result)
      return result
    },
    maxMappedData() {
      return this.data.values.reduce((accumulator, current) => {
        current.forEach((value, index) => {
          //Sum version
          /*
          !accumulator[index]
            ? (accumulator[index] = current[index])
            : (accumulator[index] += current[index])
          */
          //Max version
          if (!accumulator[index] || accumulator[index] < current[index])
            accumulator[index] = current[index]
        })
        return accumulator
      }, [])
    },
    percentageLabels() {
      return ['Δ[rel]']
    },
  },
  watch: {
    colsConfig: {
      handler() {
        this.$emit('change-col-config', this.colsConfig)
      },
      deep: true,
    },
    rows() {
      this.colsConfig = {
        currentSort: null,
        filters: null,
      }
      this.$nextTick(this.updateDataTable)
    },
    size() {
      if (this.lastWindowSize !== window.document.body.clientWidth) {
        this.lastWindowSize = window.document.body.clientWidth
        this.$nextTick(this.updateDataTable)
      }
    },
    globalFilter() {
      this._DataTable_ && this.$nextTick(this._DataTable_.draw)
    },
    // currentInsight: {
    //   handler() {
    //     // this.$nextTick(() => {
    //     if (this.data) this.gotoInsight(this.currentInsight)
    //     // })
    //   },
    //   // immediate: true,
    // },
    // data: {
    //   handler() {
    //     this.$nextTick(() => {
    //       if (this.currentInsight) this.gotoInsight(this.currentInsight)
    //     })
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    this.updateDataTable()
    // let self = this

    let matchesGlobalFilter = row => {
      // console.log('check', row, this.globalFilter)
      return (
        !this.globalFilter ||
        row.some(cellValue => {
          return cellValue.toLowerCase().indexOf(this.globalFilter.toLowerCase()) >= 0
        })
      )
    }
    // $.fn.dataTable.ext.search.push((settings, data) => {
    $.fn.dataTable.ext.search = [
      (settings, data, dataIndex) => {
        // console.log('cell search: ', settings, data, dataIndex)
        // console.log(this.colsConfig.filters[3])        
        let cols = this.data.header[this.data.header.length - 1].map(c => c.value)
        return (
          cols.every((colId, idx) => {
            //if(idx == 2) {
            //  console.log('data['+idx+'].value=' + data[idx].value);
            //  console.log('this.rows['+dataIndex+']['+idx+'].value=' + this.rows[dataIndex][idx].value);
            //}

            let filters = this.colsConfig.filters && this.colsConfig.filters[idx]
            if (!filters) return true
            else if (Array.isArray(filters)) {
              var min = filters[0]
              var max = filters[1]
              //var val = parseFloat(data[idx])
              var val = parseFloat(this.rows[dataIndex][idx].value)

              if (
                (isNaN(min) && isNaN(max)) ||
                (isNaN(min) && val <= max) ||
                (min <= val && isNaN(max)) ||
                (min <= val && val <= max)
              ) {
                return true
              } else {
                return false
              }
            } else {
              return data[idx].toLowerCase().indexOf(filters.toLowerCase()) >= 0
            }
          }) && matchesGlobalFilter(data)
        )
      },
    ]
  },

  methods: {

    setRowIdStyles(tr, data) {
      let rowIdsCount = this.pivotConfig.dimensions.filter(dim => dim.role === 'rows').length
      Array.from(Array(rowIdsCount).keys()).forEach(i => {
        let cell = $(tr.children[i])

        cell.addClass('row-id')
        // if (data[i].canHide) cell.addClass('can-hide')
        if (data[i].type !== null) {
          let indentIndex = data[i].indentIndex
          cell.addClass('indent-' + indentIndex)
        }
      })
    },
    //setRowStyles(tr, data, index)
    toggleNoteVisibility() {
      let noteEl = $(this.$refs.noteWrapper)
      noteEl[0].style.display = noteEl[0].style.display === 'flex' ? 'none' : 'flex'
    },
    setRowStyles(tr, data) {
      let self = this

      let $tr = $(tr)
      if (data[0].type === 'unselectable') {
        $tr.addClass('unselectable')
      }
      let lastHeader = this.header.slice(-1)[0]

      lastHeader.forEach((col, i) => {
        // const unit = this.percentageLabels.includes(col.label) ? '%' : ''
        // let val = col.value
        let $cell = $($tr.children()[i])
        
        // #bug-308-321:
        // Amb el nou sistema de pasar "notes" les cel·les son Objects y el valor esta a "data[i].value"
        $cell.html(data[i]?.label ? data[i].label : maskValue(data[i].value, this.dataCard, data[i].secret))
        
        // #bug-308-321:
        // Amb el nou sistema de pasar "notes" no cal buscarles, xk ja venen dins la cel·la (data[i].notes)
        
        
        //-------APENDING NOTES-------
        // let arrColsIds = self.pivotConfig.dimensions
        //   .filter(el => el.role === 'columns')
        //   .map(el => el.id)
        // let arrRowsIds = self.pivotConfig.dimensions
        //   .filter(el => el.role === 'rows')
        //   .map(el => el.id)
        // // let firstHeader = self.header[0].filter(el => el.colGroup)
        // let cellInf = {}
        // arrColsIds.forEach((v, ix) => {
        //   if (arrColsIds.length === 2 && ix === 0 && col.colGroup)
        //     cellInf[v] = firstHeader.find(he => he.colGroup * he.colSpan >= col.colGroup)?.value
        //   else cellInf[v] = col.value
        // })
        // arrRowsIds.forEach((r, ind) => {
        //   cellInf[r] = data[ind].value
        // })
        // let elementFound = self.data.notes?.find(el => {
        //   let count = 0
        //   Object.keys(cellInf).forEach(k => {
        //     if (el[k] === cellInf[k]) count += 1
        //   })
        //   return Object.keys(cellInf).length === count
        // })
        if (data[i].notes) {
          let noteDiv = document.createElement('div')
          noteDiv.style.borderBottom = '7px solid #000'
          noteDiv.style.borderLeft = '7px solid transparent'
          noteDiv.style.height = '0px'
          noteDiv.style.width = '0px'
          noteDiv.style.position = 'absolute'
          noteDiv.style.bottom = 0
          noteDiv.style.right = 0
          $cell.append(noteDiv)
          $cell.addClass('note-cell')
          $cell[0].addEventListener(
            'click',
            function (event) {
              var pos = event.currentTarget.getBoundingClientRect()
              let tableEl = self.$refs.tableWrapper.getBoundingClientRect()
              let noteEl = $(self.$refs.noteWrapper)
              let noteText = $(self.$refs.noteText)
              // #bug-308-321
              // Les notes estan (si nhi ha) dins de la cel·la (data[i]={value:xxx,notes:yyy})
              noteText[0].innerText = data[i].notes
              self.toggleNoteVisibility()
              let top = pos.bottom - tableEl.top + 'px'
              let left = pos.left - tableEl.left + 'px'
              noteEl[0].style.top = top
              noteEl[0].style.left = left

              let noteWrap = self.$refs.noteWrapper.getBoundingClientRect()
              if (noteWrap.right > window.innerWidth) {
                noteEl[0].style.left = noteWrap.left - (noteWrap.right - window.innerWidth) + 'px'
              }
            },
            false
          )
        }
        //-------------
        if (col.isEmptyCol) {
          $cell.addClass('empty-col')
        }
      })

    },
    setHeaderStyles(thead) {
      // console.log(thead, data, start, end, display)
      let lastHeader = this.header.slice(-1)[0]
      let $thead = $(thead)
      lastHeader.forEach((col, i) => {
        if (col.isEmptyCol) {
          $($thead.children()[i]).addClass('empty-col')
        }
      })
    },

    resetAllCols() {
      this.colsConfig = {
        currentSort: null,
        filters: null,
      }
      this._DataTable_.order([0, 'asc'])
      // this.colsConfig.filters = []
      this._DataTable_.draw()
    },
    clearColConfig() {
      this.activeConfigCol.filter = null
      this.activeConfigCol.dir = null
    },
    setTempConfigCol(dir) {
      this.activeConfigCol.dir = dir
      this.showColDropdown()
    },

    // Función para comparar y ordenar según tipo de dato
    compareValues(a, b, type) {
        //console.log('compareValues');
        //console.log('A=' + a + ' ; B=' + b);
        if (type === 'number') {
            if (a.value && b.value) {
              return a.value - b.value; // Comparación numérica
            } else if (!a.value && b.value) {
              //console.log('a='+a+' b='+b.value+' -> -1');
              return 0 - b.value;
            } else if (a.value && !b.value) {
              //console.log('a='+a.value+' b='+b+' -> 1');
              return a.value;
            }
            
        } else if (type === 'string') {
          return a.label.localeCompare(b.label); // Comparación de cadenas          
        }
        return 0; // Si no se reconoce el tipo, devuelve 0
    },
    getColumnType(columnIndex) {
      //console.log('getColumnType');
      const values = this.data.values.map(row => row[columnIndex]);
      let hasNumber = false;
      let hasString = false;
      //console.log(values);

      values.forEach(value => {
        //console.log('value=' + value);
        if (value && value != undefined && '-' !== value) {
          //if (typeof value === 'number' && !isNaN(value)) {
          if (!isNaN(Number(value.value))) {
            hasNumber = true;
          } else {
            hasString = true;
          }
        }
      });

      //console.log('hasNumber=' + hasNumber + ' ; hasString=' + hasString);
      // Determinar el tipo de la columna basándose en los valores encontrados
      if (hasNumber && hasString) {
        return 'string'; // Si hay tanto números como cadenas
      } else if (hasNumber) {
        return 'number'; // Solo hay números
      } else {
        return 'string';      
      }
    },

    applyColConfig() {
      //console.log('this.activeConfigCol.dir=' + this.activeConfigCol.dir);
      if (this.activeConfigCol.dir && this.activeConfigCol.dir !== 'reset') {
        this.colsConfig.currentSort = {
          index: this.activeConfigCol.index,
          dir: this.activeConfigCol.dir,
        };

        //const colType = this.colFilterTypes[this.activeConfigCol.index]; // Obtener el tipo de columna
        const colType = this.getColumnType(this.activeConfigCol.index);
        //console.log('colType=' + colType);
        //console.log('this.activeConfigCol.index=' + this.activeConfigCol.index);
        //console.log(this.rows);
        this.rows.sort((a, b) => {
          return this.compareValues(
            a[this.activeConfigCol.index],
            b[this.activeConfigCol.index],
            colType
          ) * (this.activeConfigCol.dir === 'asc' ? 1 : -1); // Considerar la dirección
        });
      } else if (!this.activeConfigCol.dir || this.activeConfigCol.dir == 'reset') {
        this.colsConfig.currentSort = {}
        // NO ESTA NADA CLARO QUE ESTO SEA "el orden original" == "el orden del configGroup rows"
        this._DataTable_.order([0, 'asc'])
      }

      // this.colsConfig.filters = {}
      if (this.activeConfigCol.filter) {
        this.colsConfig.filters = {}
        this.colsConfig.filters[this.activeConfigCol.index] = this.activeConfigCol.filter
      } else if (this.colsConfig.filters && this.colsConfig.filters[this.activeConfigCol.index]) {
        delete this.colsConfig.filters[this.activeConfigCol.index]
      }

      if (
        this.colsConfig.filters &&
        Object.entries(this.colsConfig.filters).length === 0 && 
        (!this.colsConfig.currentSort || Object.entries(this.colsConfig.currentSort).length === 0)
      ) {
        this.colsConfig.filters = null
        this.colsConfig.currentSort = null
      } else {
        this.colsConfig = { ...this.colsConfig }
        //console.log(this.colsConfig);
      }

      //console.log(this.rows);
      this.hideColDropdown();
      this.rows.forEach((row, index) => {
        this.$set(this.rows, index, row); // Actualiza cada fila
      });
      //console.log(this.rows);
      //console.log('dibujando');
      //this._DataTable_.clear().rows.add(this.rows).draw();
      // Guardamos el estado de ordenamiento actual
      let currentOrder = [this.activeConfigCol.index, this.activeConfigCol.dir];
      if (!this.activeConfigCol.dir || this.activeConfigCol.dir == 'reset') {
        this.colsConfig.currentSort = {}
        currentOrder = [0, 'asc'];
      }
      //console.log(currentOrder);
      // Limpiamos la tabla
      this._DataTable_.clear();
      // Agregamos las filas
      this._DataTable_.rows.add(this.rows);
      this._DataTable_.order(currentOrder).draw();
      //this._DataTable_.draw(); // Redibuja la tabla
    },

    onDropdownClickOutside() {
      if (this.activeConfigCol) this.hideColDropdown()
    },
    hideColDropdown() {
      $(this.$refs.colDropdown).removeClass('visible')

      let $header = $(this.$el).find('.dataTables_scrollHead')
      $header
        .find('tr')
        .last()
        .find('th')
        .each((i, el) => {
          let $icon = $(el).find('.filter-sort-icon')
          $icon.removeClass('icon-visible')
        })
    },
    showColDropdown() {
      $(this.$refs.colDropdown).addClass('visible')
    },
    updateDataTable() {
      if (this.header) {
        let $table = $(this.$refs.table)
        if (this._DataTable_) {
          $table.off('draw.dt')
          $table.off('column-sizing.dt')
          this._fixedColumns_.destroy()
          this._DataTable_.clear()
          this._DataTable_.destroy()
          $table.empty()
        }

        let $header = $('<thead></thead>')
        let dropdownParent = $(this.$refs.tableWrapper)
        let dropdown = $(this.$refs.colDropdown)
        let self = this
        this.header.forEach((hr, i) => {
          let $tr = $('<tr></tr>').appendTo($header)
          let isLast = i === this.header.length - 1
          hr.forEach((h, j) => {
            if (isLast) {
              $tr.append(
                `<th colspan="${h.colSpan}" style="min-width: ${
                  this.isMobile ? '70px' : '100px'
                }; max-width: ${this.isMobile ? '70px' : '100px'}" class="${h.groupClass}">
                <div class="icons-container" style="display: flex; ${
                  h.groupClass.includes('no-group')
                    ? 'width: 100%; margin-left: 0; justify-content: space-between;'
                    : 'width: calc(100% + 20px); margin-left: -20px; justify-content: flex-end;'
                } gap: 5px">
                  <span>${h.label}</span>
                  <div data-index="${j}" class="sort-and-filter"><div class="filter-sort-icon" />
                </div>
                </div></th>`
              )
            } else {
              $tr.append(`<th colspan="${h.colSpan}" class="${h.groupClass}">${h.label}</th>`)
            }
          })
          $tr.find('.sort-and-filter').on('click', function (e) {
            setTimeout(() => {
              let colIndex = +e.currentTarget.getAttribute('data-index')
              // let colId = e.currentTarget.getAttribute('data-id')
              // let colIndex = self.header[self.header.length - 1].findIndex(hh => hh.value === colId) //e.currentTarget.getAttribute('data-index')
              let currSort =
                self.colsConfig?.currentSort?.index === colIndex && self.colsConfig.currentSort.dir
              let currFilter =
                (self.colsConfig?.filters && self.colsConfig?.filters[colIndex]) || null
              self.activeConfigCol = {
                index: colIndex,
                // id: colId,
                dir: currSort,
                filter: currFilter,
                filterType: self.colFilterTypes[colIndex],
                fullRange: self.colRanges[colIndex],
              }
              if (e.currentTarget.children[0].className.indexOf('icon-visible' === -1))
                e.currentTarget.children[0].className = 'filter-sort-icon icon-visible'

              self.showColDropdown()
              // let scrollRef = $('.dataTables_scrollHead')
              let rect = this.parentElement.getBoundingClientRect()
              let offset = $header.closest('.table-wrapper')[0].getBoundingClientRect()

              let isLast = colIndex === self.header[self.header.length - 1].length - 1
              dropdown.css({
                left: self.isMobile
                  ? undefined
                  : isLast
                  ? rect.left - offset.left + rect.width
                  : rect.left - offset.left,
                transform: isLast ? 'translate(-100%,0)' : '',
                top: rect.top - offset.top + rect.height,
                right: self.isMobile ? 0 : undefined,
              })
              dropdownParent.append(dropdown)
            }, 1)
          })
        })

        let rowIdsCount = self.pivotConfig.dimensions.filter(dim => dim.role === 'rows').length
        let cols = this.header[this.header.length - 1].map((h, i) => {
          let colDef = { targets: [i] }
          if (i < rowIdsCount)
            colDef.render = {
              _: 'label',
              sort: 'index',
            }

          // OTRAS "first columns" NO SE PUEDEN SORTEAR!
          // else if (h.type === 'row') {
          //   colDef.orderable = false
          // }
          // DE MOMENTO DESCTIVO EL SORTING "NATIVO"
          colDef.orderable = false
          colDef.searchable = true
          colDef.width = 100
          // colDef.width = Math.max(100 / this.header[this.header.length - 1].length, 30) + '%'
          //VERY DANGEROUS //mejor como esta con los ".empty-col"
          // colDef.visible = !h.isEmptyCol
          return colDef
        })
        $table.append($header)
        this._DataTable_ = $table.DataTable({
          searching: true,
          paging: false,
          data: this.rows,
          ordering: true,
          scrollCollapse: true,
          columns: cols,

          scrollY: this.size.height - 120, //(parece que "fixedHeader" + "Scrolly" no lo sabe hacer...)
          scrollX: true,
          info: false,
          autoWidth: false,
          // asStripeClasses: [''],
          createdRow: (row, data, dataIndex) => {
            this.setRowStyles(row, data, dataIndex)
            this.setRowIdStyles(row, data, dataIndex)
          },
          headerCallback: (thead, data, start, end, display) => {
            thead = $(thead).parent().children().last()[0]
            this.setHeaderStyles(thead, data, start, end, display)
          },
          // createdCell: function(td, cellData, rowData, row, col) {
          //   // if (cellData < 1) {
          //   //   $(td).css('color', 'red')
          //   // }
          //   this.setRowContent(td, cellData, rowData, row, col)
          // },
        })
        this._fixedColumns_ = new $.fn.dataTable.FixedColumns($table, {
          leftColumns: this.pivotConfig.dimensions.filter(dim => dim.role === 'rows').length,
          sHeightMatch: 'none',
        })

        $(this.$refs.table).addClass('should-hide')
        this._DataTable_.on('order.dt', () => {
          let order = this._DataTable_?.order()
          if (!order[0] || order[0][0] === 0) $(this.$refs.table).addClass('should-hide')
          else $(this.$refs.table).removeClass('should-hide')
        })

        $table.on('draw.dt', () => {
          this.emitSearchChange()
          console.log('should update header styles')
          let $header = $(this.$el).find('.dataTables_scrollHead')
          $header
            .find('tr')
            .last()
            .find('th')
            .each((i, el) => {
              let $icon = $(el).find('.sort-and-filter')
              $icon.removeClass('filtering').removeClass('sorting-asc').removeClass('sorting-desc')
              if (this.colsConfig.currentSort && this.colsConfig.currentSort.index === i) {
                $icon.addClass('sorting-' + this.colsConfig.currentSort.dir)
              }
              // let colId = $icon.attr('data-id')
              if (this.colsConfig.filters && this.colsConfig.filters[i]) {
                $icon.addClass('filtering')
              }
            })
        })

        this.emitSearchChange()

        $table.on('mouseenter', 'td', function () {
          var colIdx = self._DataTable_.cell(this).index().column

          $(self._DataTable_.cells().nodes()).removeClass('highlight')
          $(self._DataTable_.column(colIdx).nodes()).addClass('highlight')
          let header = $(self.$el).find('.dataTables_scrollHead')
          header
            .find('tr')
            .last()
            .find('th')
            .each((i, el) => {
              if (i === colIdx) {
                el.classList.add('highlight')
              } else el.classList.remove('highlight')
            })
        })

        $table.closest('.dataTables_scrollBody').on('scroll', e => {
          let noteEl = $(this.$refs.noteWrapper)
          noteEl[0].style.display = 'none'
          this.onDropdownClickOutside()
          this.lastScroll = {
            top: e.target.scrollTop,
            left: e.target.scrollLeft,
          }
        })
      }
      this.recoverScroll()
    },
    emitSearchChange() {
      let totalTableRows = this._DataTable_?.rows().count()
      this.$emit(
        'change-search',
        this._DataTable_?.rows({ search: 'applied' }).count(),
        totalTableRows
      )
    },
    recoverScroll() {
      let $scrollParent = $(this.$refs.table).closest('.dataTables_scrollBody')
      let $tbody = $scrollParent.find('tbody')
      // if (!this.lastScroll) {
      this.lastScroll = { top: 0, left: $tbody.width() }
      // }
      $scrollParent.animate(
        {
          scrollTop: this.lastScroll.top,
          scrollLeft: this.lastScroll.left,
        },
        0
        // () => {
        //   console.log('SCROLLED OK')
        // }
      )
      if (!isOverflownX($scrollParent[0])) $(this.$el).addClass('no-overflow-x')
      else $(this.$el).removeClass('no-overflow-x')
      if (!isOverflownY($scrollParent[0])) $(this.$el).addClass('no-overflow-y')
      else $(this.$el).removeClass('no-overflow-y')
    },
    // gotoInsight(insight) {
    //   // console.log('should scroll to ', insight)
    //   let cellId = insightCellId(insight)
    //   let $cell = $('#' + cellId)

    //   // $cell.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
    //   let scrollParent = $($cell.closest('.dataTables_scrollBody'))

    //   let rect = $cell[0].getBoundingClientRect()
    //   let offset = scrollParent[0].getBoundingClientRect()
    //   let scrollOffset = { top: scrollParent.scrollTop(), left: scrollParent.scrollLeft() }
    //   this.hideInsightTooltip()
    //   $cell.addClass('sim-hover')
    //   scrollParent.animate(
    //     {
    //       scrollTop: rect.top - offset.top + scrollOffset.top - offset.height / 2,
    //       scrollLeft: rect.left - offset.left + scrollOffset.left - offset.width / 2,
    //     },
    //     400,
    //     () => {
    //       $cell = $('#' + cellId)
    //       this.showInsightTooltip(insight, $cell)
    //       $cell.addClass('sim-hover')
    //     }
    //   )
    // },
  },
}
</script>

<style lang="stylus" scoped>
$group-border-separation = 8px

m-fake-right-border($color = #000)
  &:before
    position: absolute
    top: 0
    right: 0
    z-index: 1
    width: 1px
    height: 100%
    background-color: $color
    content: ""

.table
  m-font-size(14, 16)

  .mobile &
    m-font-size(12, 20)

.col-dropdown
  position: absolute
  z-index: 4
  display: none
  flex-direction: column
  padding: vw(8px) vw(6px) 0
  width: vw(250px)
  border: solid 1px #ddd
  border-radius: vw(7px)
  background: #fff
  // height 200px
  box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.05)
  transform: translate(-10px, 10px)
  gap: vw(5px)

  &.visible
    display: flex

  .sort-option
    display: flex
    align-items: center
    cursor: pointer

    &.active
      color: $corporate_color
      font-weight: bold

    .icon
      margin: vw(4px)

    &.asc
      .icon
        m-icon("arrow-back", 18)
        transform: rotate(90deg)

      &.active
        .icon
          m-icon("arrow-back", 18, $corporate_color)

    &.desc
      .icon
        m-icon("arrow-back", 18)
        transform: rotate(-90deg)

      &.active
        .icon
          m-icon("arrow-back", 18, $corporate_color)

    &.reset
      .icon
        m-icon("refresh", 18)

      &.active
        .icon
          m-icon("refresh", 18, $corporate_color)

  .actions
    display: inline-flex
    margin: 0
    padding: vw(10px)
    width: 100%
    gap: vw(5px)

    .action-button
      display: flex
      justify-content: center
      align-items: center
      padding: vw(8px)
      width: 100%
      border: solid 1px
      cursor: pointer

      &.main
        background: #000
        color: #fff

.table
  // position: absolute
  // display: flex
  // flex-direction: column
  // // padding: vw(20px) vw(20px) vw(10px)
  // width: 100%
  .mobile &
    padding: 0

  .table-wrapper
    position: relative
    overflow-y: visible

    .note-abs
      position: absolute
      display: none

      .note-wrapper
        position: relative
        padding: vw(10px)
        width: vw(300px)
        z-index: 4
        border: 1px solid $bcn-grey
        border-radius: 6px
        background-color: white

        h4
          margin-block-start: 0
          margin-block-end: 0
          m-font-size(18, 26)
          font-weight: 400

        span
          m-font-size(14, 22)
          font-weight: 300

        .close-wrap
          position: absolute
          top: vw(8px)
          right: vw(8px)
          display: flex
          justify-content: center
          align-items: center
          width: vw(28px)
          height: vw(28px)
          border: 1px solid $bcn-border-grey
          border-radius: 50%
          cursor: pointer

          &:hover
            background-color: $bcn-grey

          .icon-close
            m-icon("close", 25px)

    // overflow: hidden
    // width: 400px
    // height: 300px

    // no se como quitarlo y que siga funcionando el ".search"...
    // Pero NO se si este nos vale...
    >>> .dataTables_filter
      display: none

    >>> .dataTables_scrollBody
      border: none

      th
        opacity: 0

    >>> table
      width: auto

      &.should-hide
        .can-hide
          position: relative
          opacity: 1

          &:after
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%
            background: #fff
            content: ""
            opacity: 1

    >>> table
      border-spacing: 0
      border-collapse: collapse

      thead
        tr
          th
            position: relative
            padding: 10px 10px 10px vw(45px) // delicado, hay unos paddings de la "dataTalbe" peor queremos dejar MAS espacio a la derecha para los "sort-and-filter"
            border: none
            background: $bcn-table-even
            background-image: none !important
            box-shadow: -1px 0 0 0 #ddd inset, 0 1px 0 0 #ddd inset, 0 -1px 0 0 #ddd inset
            text-align: right
            font-weight: 600
            word-break: break-word

            &:after
              display: none
              content: ""

            &.highlight
              background-color: #f8f8ff // color de columna highlithed
              box-shadow: 0 0 0 1px $corporate_color_light inset

            &:hover
              background: $bcn-table-even

            // width 120px
            &.row-id
              m-fake-right-border()

            .icons-container
              align-items: center
              min-height: vw(20px)

              span
                text-align: left

            .sort-and-filter
              display: flex
              opacity: 1
              cursor: pointer
              transition: opacity 0.3s

              &.sorting-asc
                &:before
                  display: flex
                  width: vw(18px)
                  height: vw(18px)
                  content: " "
                  m-icon("order-up-blue", 18)

              &.sorting-desc
                &:before
                  m-icon("order-up-blue", 18)
                  display: flex
                  width: vw(20px)
                  height: vw(20px)
                  content: " "
                  transform: rotate(180deg)

              &.filtering
                .filter-sort-icon
                  display: flex
                  m-icon("sort-blue", 20)

              .filter-sort-icon
                display: none
                m-icon("sort", 20)

              .icon-visible
                opacity: 1

            &:hover
              .sort-and-filter
                opacity: 1

                .filter-sort-icon
                  display: flex

            &.empty-col
              display: none
              opacity: 0.3

              .sort-and-filter
                visibility: hidden

            &.group-first
              &:after
                margin-left: $group-border-separation
                width: "calc(100% - %s)" % $group-border-separation

            &.group-last
              &:after
                width: "calc(100% - %s)" % $group-border-separation

            &.group-first.group-last
              &:after
                margin-left: $group-border-separation
                width: "calc(100% - %s)" % (2 * $group-border-separation)

            &.no-group
              &:after
                display: none

            &.dtfc-fixed-left
              z-index: 1
              padding: 10px vw(45px) 10px 10px
              m-fake-right-border()

              // Para tapar el "segundo header en la primera columna" cuando tenemos multiples dims a columns
              &:after
                position: absolute
                top: calc(-200% - 1px)
                left: 0
                left: -1px
                display: block
                width: calc(100% + 2px)
                height: 200%
                background: #fff
                content: ""
                opacity: 1

              .sort-and-filter
                transform: translateX(22px)

      tbody
        tr
          &.unselectable
            td
              height: vw(16px) !important

              &.note-cell
                div
                  display: none

          &.odd
            background-color: #ffffff

            &.unselectable
              td:first-child
                background-color: #ffffff !important
                box-shadow: none !important

            td
              background-color: #ffffff

          &.even
            background-color: $bcn-table-even

            &.unselectable
              td:first-child
                background-color: $bcn-table-even !important
                box-shadow: none !important

            td
              background-color: $bcn-table-even

          // ESTILOS "HIGHLIGHT" on mouse over
          &.even
            td
              &.highlight
                // background-color: #f6f6ff

          &:hover
            &.unselectable
              &.even
                td.highlight
                  background-color: $bcn-table-even !important

              &.odd
                td.highlight
                  background-color: #ffffff !important

            td
              // background-color: #f8f8ff // color de fila highlithed
              &.highlight
                background-color: $bcn-table-highlight // color de elemento highlithed

            td:first-child
              border: none
              background-color: $corpotative-color-very-light // color de primer elemento fila highlithed
              box-shadow: 0 0 0 1px $corporate_color_light inset

          td
            position: relative
            box-sizing: content-box
            padding: vw(10px)
            min-width: 100px !important
            max-width: 100px !important
            width: 100px !important
            box-shadow: inset -1px 0 0 0 #ddd
            text-align: right
            font-weight: 400
            word-wrap: break-word

            .mobile &
              min-width: 70px !important
              max-width: 70px !important
              width: 70px !important

            &.row-id
              // m-first-letter-case()
              m-fake-right-border()
              z-index: 1
              padding-left: vw(10px)
              text-align: left

              &.note-cell
                div
                  display: none

              &.can-drill-down
                cursor: pointer

              &.indent-0
                padding-left: vw(10px)

              &.indent-1
                padding-left: vw(25px)
                min-width: unset !important
                max-width: unset !important
                width: unset !important

              &.indent-2
                padding-left: vw(40px)
                min-width: unset !important
                max-width: unset !important
                width: unset !important

              &.indent-3
                padding-left: vw(55px)
                min-width: unset !important
                max-width: unset !important
                width: unset !important

              &.indent-4
                padding-left: vw(70px)
                min-width: unset !important
                max-width: unset !important
                width: unset !important

              &.indent-5
                padding-left: vw(85px)
                min-width: unset !important
                max-width: unset !important
                width: unset !important

            &.has-insight
              position: relative
              border: solid 1px $seat-orange
              transition: box-shadow 0.4s

              &:after
                position: absolute
                top: 0
                right: 0
                width: 0
                height: 0
                border-top: 18px solid $seat-orange
                border-left: 18px solid transparent
                content: ""

              &:hover,
              &.sim-hover
                z-index: 1
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3)

            &.empty-col
              position: relative
              display: none

              &:after
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%
                background: #ffffff
                content: ""

          &.bold-row
            td
              position: relative
              font-weight: 600

              &:before
                position: absolute
                bottom: 0
                left: 0
                width: 100%
                height: 2px
                background: #000
                content: ""

          &.cond-high
            td
              background-color: #dde

    >>> .dataTables_empty
      display: none

  .table-footer
    padding: vw(5px)
    border-top: solid 1px #111

  .insight-tooltip
    position: absolute
    z-index: 2
    padding: vw(10px)
    max-width: 300px
    border: solid 1px #ddd
    background: #fff
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3)
    opacity: 1
    pointer-events: none

    &.flip-v
      transform: translate(-100%, 0)

    &.flip-h
      transform: translate(0, 100%)

    &.fade-enter-active,
    &.fade-leave-active
      transition: all 0.3s

    &.fade-enter,
    &.fade-leave-to /* .fade-leave-active below version 2.1.8 */
      opacity: 0

.dataTable thead th.sorting:before,
.dataTable thead th.sorting_asc:before,
.dataTable thead th.sorting_desc:before
  position: absolute
  top: 50%
  right: 0
  transform: translate(0, -50%)

.no-overflow-x
  margin: 0 auto
  width: 100% !important

  >>> .dataTables_scrollHeadInner
    margin: 0 !important
    width: 100% !important
    background-color: $bcn-table-even

    table
      width: auto !important

  >>> .dataTables_scrollBody
    width: 100% !important

    table
      margin: 0 !important
      width: 100% !important

      tr:after
        position: relative
        width: 100vw
        height: auto
        content: ""

.no-overflow-y
  >>> .dataTables_scrollHeadInner
    width: 100% !important
</style>
